import { askrClients } from "../../providers/AskrProvider";
import {
  useDetectSerialProcess,
  useHideOverflow,
} from "../../utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { GridLayoutPageStyles } from "./GridLayoutPageStyles";
import { TrendChartBinSizesEnum } from "../../types/enums";
import { useResetTrendChartBinSize } from "../DashboardPages/dashboardPagesUtils";
import StayOnCurrentShift from "../../components/Dashboard/range-selectors/StayOnCurrentShift";
import GridLayout from "./GridLayout";
import useContainerDimensions from "utils/useContainerDimensions";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import { GridLayoutPageGuidedTour } from "components/SimpleComponents/GuidedTour/GuidedTours";
import {
  useHidePnlCategoriesPerCustomer,
  useSetFocusRangeOnMount,
} from "pages/DashboardPages/DashboardPagesContent/InitializeDashboardPagesHooks";
import { ApolloProvider } from "@apollo/client";
import useWindowSize from "utils/customHooks/useWindowSize";
import { getScaleFromWidthForLargeScreens } from "pages/DashboardPages/DashboardPagesContent/dashboardPagesContentUtils";
import { useBreakpoints } from "constants/constants";
import { GlobalPopupMenuResponsiveStyles } from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";

const GridLayoutPageContent = () => {
  useHideOverflow(true); // always hide overflow on grid page

  const ckey = useCustomerKey();
  useDetectSerialProcess();
  useHidePnlCategoriesPerCustomer();

  // set trend chart to hourly bin size (only one allowed on Dashboard Pages)
  useResetTrendChartBinSize({
    newTrendChartBinSize: TrendChartBinSizesEnum.hours,
  });
  const [ref, dimensions] = useContainerDimensions();
  const width = dimensions.width || 0;
  const height = dimensions.height || 0;

  useSetFocusRangeOnMount();

  if (!ckey) {
    return null;
  }

  return (
    <>
      <StayOnCurrentShift />
      <div
        style={{
          height: "100%",
        }}
        ref={ref as any}
      >
        <GridLayout width={width} height={height} />
      </div>
    </>
  );
};

const GridLayoutPage = () => {
  const ckey = useCustomerKey();
  const { isTourEnabled } = useSettings();
  const { innerWidth } = useWindowSize();
  const scale = getScaleFromWidthForLargeScreens(innerWidth);
  const { isDesktopXlOrLarger } = useBreakpoints();
  return (
    <ApolloProvider client={askrClients.get(ckey)}>
      {isTourEnabled && <GridLayoutPageGuidedTour />}
      <GridLayoutPageStyles {...{ $scale: scale }}>
        <GridLayoutPageContent />
      </GridLayoutPageStyles>
      {isDesktopXlOrLarger ? (
        <GlobalPopupMenuResponsiveStyles {...{ $scale: scale }} />
      ) : null}
    </ApolloProvider>
  );
};

export default GridLayoutPage;
